module.exports = __webpack_public_path__ + "img/51.56b87d64.jpg";